export const MessageWithNotification = ({
    color = 'var(--ink-light)',
    height = '21px',
    notificationColor = 'var(--red)',
    width = '23px',
    ...props
}: {
    color?: string;
    height?: string;
    notificationColor?: string;
    width?: string;
}): JSX.Element => (
    <svg width={width} height={height} viewBox="0 0 23 21" {...props}>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="message">
                <path
                    d="M11,5 C11,5.69535399 11.1013887,6.36702737 11.2901893,7.00104324 L2,7 L10,12 L13.1405514,10.0384382 C13.5778743,10.4603203 14.0699788,10.8257939 14.6051487,11.1231427 L10,14 L2,9 L2,19 L18,19 L18,12 L18,12 C18.695354,12 19.3670274,11.8986113 20.0010432,11.7098107 L20,19 C20,20.1 19.1,21 18,21 L18,21 L2,21 C0.9,21 7.05213665e-13,20.1 7.05213665e-13,19 L7.05213665e-13,19 L7.05213665e-13,7 C7.05213665e-13,5.9 0.9,5 2,5 L2,5 L11,5 L11,5 Z"
                    fill={color}
                    fillRule="nonzero"
                ></path>
                <circle fill={notificationColor} cx="18" cy="5" r="5"></circle>
            </g>
        </g>
    </svg>
);
